import { scaleLinear } from 'd3-scale';
import { min as d3Min, max as d3Max } from 'd3-array';
var xAccessor = function (d, i) { return (d[0] ? d[0] : i); };
var yAccessor = function (d) { return d[1]; };
var min = function (data, accessor) { return d3Min(data, accessor) || 0; };
var max = function (data, accessor) { return d3Max(data, accessor) || 100; };
export var getScaleX = function (width, data) {
    return scaleLinear().domain([min(data, xAccessor), max(data, xAccessor)]).rangeRound([0, width]);
};
export var getScaleY = function (height, data) {
    return scaleLinear().domain([0, max(data, yAccessor)]).range([height, 0]);
};
//# sourceMappingURL=utils.js.map